import Image from 'next/image';
import Emergency from '@public/Assets/Icons/Emergency.svg';
import Fire from '@public/Assets/Icons/Fire.svg';
import Hospital from '@public/Assets/Icons/Hospital.svg';
import Hotel from '@public/Assets/Icons/Hotel.svg';
import Meat from '@public/Assets/Icons/Meat.svg';
import PoopWithEyes from '@public/Assets/Icons/PoopWithEyes.svg';
import Salon from '@public/Assets/Icons/Salon.svg';
import Store from '@public/Assets/Icons/Store.svg';
import TeaCafe from '@public/Assets/Icons/TeaCafe.svg';
import Toy from '@public/Assets/Icons/Toy.svg';
import Travel from '@public/Assets/Icons/Travel.svg';
import Walk from '@public/Assets/Icons/Walk.svg';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';

interface FlatIconProps {
  type:
    | 'Emergency'
    | 'Fire'
    | 'Hospital'
    | 'Hotel'
    | 'Meat'
    | 'PoopWithEyes'
    | 'Salon'
    | 'Store'
    | 'TeaCafe'
    | 'Toy'
    | 'Travel'
    | 'Walk';
}

const icons: Record<FlatIconProps['type'], StaticImport> = {
  Emergency: Emergency as StaticImport,
  Fire: Fire as StaticImport,
  Hospital: Hospital as StaticImport,
  Hotel: Hotel as StaticImport,
  Meat: Meat as StaticImport,
  PoopWithEyes: PoopWithEyes as StaticImport,
  Salon: Salon as StaticImport,
  Store: Store as StaticImport,
  TeaCafe: TeaCafe as StaticImport,
  Toy: Toy as StaticImport,
  Travel: Travel as StaticImport,
  Walk: Walk as StaticImport,
};

export const EmojiAtom: React.FC<FlatIconProps> = ({ type }) => {
  const IconComponent = icons[type];
  return (
    <section className='p-[2px]'>
      <Image src={IconComponent} alt={type} />
    </section>
  );
};
